import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { ToggleControl } from '@wordpress/components';

function BaseOption(_ref) {
  let {
    help,
    label,
    isChecked,
    onChange,
    children
  } = _ref;
  return createElement("div", {
    className: "interface-preferences-modal__option"
  }, createElement(ToggleControl, {
    __nextHasNoMarginBottom: true,
    help: help,
    label: label,
    checked: isChecked,
    onChange: onChange
  }), children);
}

export default BaseOption;
//# sourceMappingURL=index.js.map